import type React from 'react';

import { Button } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { type TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';
import cx from 'classnames';

import ArrowRight from 'assets/icons/icn _ 16px _ Arrow right 2.svg?react';
import ArrowLeft from 'assets/icons/icn _ 24px _ Arrow left 2.svg?react';

import { useStyles } from './styles';

const TablePaginationActions: React.FC<React.PropsWithChildren<TablePaginationActionsProps>> = (props) => {
  const { classes } = useStyles();
  const { count, page, rowsPerPage, onPageChange, className } = props;
  const numberOfPages = Math.ceil(count / rowsPerPage);

  const handleChange = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, page: number) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (page + 1 < numberOfPages) onPageChange(event, page + 1);
  };

  const handlePrevButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (page + 1 > 1) onPageChange(event, page - 1);
  };

  const handleIsSelected = (item: any): boolean => {
    return item.page === page + 1;
  };

  return (
    <div className={className || classes.paginationActions}>
      <Button disableRipple className={className || classes.buttonPrevious} onClick={handlePrevButtonClick}>
        <ArrowLeft />
      </Button>
      <Pagination
        hideNextButton
        hidePrevButton
        classes={{ ul: className || classes.itemsContainer }}
        count={numberOfPages}
        defaultPage={1}
        page={page + 1}
        renderItem={(item: any) => {
          return (
            <PaginationItem
              {...item}
              classes={{ ellipsis: classes.paginationItemEllipsis }}
              className={cx(
                className,
                handleIsSelected(item) ? classes.paginationItemSelected : classes.paginationItem,
              )}
              component="button"
              page={item.page}
              selected={handleIsSelected(item)}
              shape="rounded"
              size="medium"
              variant="text"
              onClick={(e) => handleChange(e, item.page)}
            />
          );
        }}
        {...(className && { siblingCount: 0 })}
      />
      <Button disableRipple className={className || classes.buttonNext} onClick={handleNextButtonClick}>
        <ArrowRight />
      </Button>
    </div>
  );
};

export default TablePaginationActions;
